module.exports = __webpack_public_path__ + "static/media/id-verified.89f90035.png";